import { useWidgetVisibility } from '../../../hooks/useWidgetVisibility.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { type IRowWidget } from './IRowWidget.ts';

export interface IRowWidgetProps extends IWidgetComponentProps<IRowWidget> {}

export function RowWidgetComponent(props: IRowWidgetProps) {
  const options = getWidgetProps(props);
  const visible = useWidgetVisibility(props.widget, options);

  if (!visible) return null;

  return <>{props.children}</>;
}
